import { GuidelinesRepo } from '@/modules/guidelines/domain/GuidelinesRepo'
import { GuidelineDetailScreenData } from '../domain/GuidelinesScreenData'

export class GuidelineDetailComponent {

    guidelines_repo: GuidelinesRepo
    screen_data: GuidelineDetailScreenData

    constructor(guidelines_repo, screen_data) {
        this.guidelines_repo = guidelines_repo
        this.screen_data = screen_data
    }

    async fetchGuideline(g_id: number) {
        this.screen_data.loading = true
        this.screen_data.guideline = await this.guidelines_repo.find_by_id(g_id)
        this.screen_data.loading = false
    }

    async fetchOptions() {
        let res = await this.guidelines_repo.get_options()
        this.screen_data.condition_options = res.conditions
        this.screen_data.consequence_options = res.consequences
    }

    async saveGuideline() {
        this.screen_data.loading = true
        let new_guideline_id = await this.guidelines_repo.save(this.screen_data.guideline)
        console.log(new_guideline_id)
        this.screen_data.loading = false
        await this.fetchGuideline(new_guideline_id)
    }

    async deleteGuideline() {
        this.screen_data.loading = true
        let res =await this.guidelines_repo.delete(this.screen_data.guideline)
        this.screen_data.loading = false
        if (res.OK){
            return true
        }
        return false
    }

    async getGuidelineStats() {
        this.screen_data.execution_stats = await this.guidelines_repo.get_guideline_stats(this.screen_data.guideline.id)
    }
}